import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { RoundButton } from 'ui/Buttons';
import { Tooltip } from '@mui/material';

const RequestEsgButton = ({ onRequestClick, alreadyRequested, disabled, tooltip, className }) => {
  const { t } = useTranslation();

  const openModal = () => {
    onRequestClick();
  };

  const renderButton = (
    <div {...(className && { className })}>
      <RoundButton
        color="success"
        onClick={openModal}
        disableRipple={alreadyRequested}
        disabled={alreadyRequested || disabled}
        label={!alreadyRequested ? t('Request') : t('Requested')}
      />
    </div>
  );

  return tooltip ? <Tooltip title={tooltip}>{renderButton}</Tooltip> : renderButton;
};

RequestEsgButton.defaultProps = {
  onRequestClick: undefined,
  alreadyRequested: false,
  disabled: false,
  className: undefined,
  tooltip: '',
};

RequestEsgButton.propTypes = {
  onRequestClick: PropTypes.func,
  alreadyRequested: PropTypes.bool,
  disabled: PropTypes.bool,
  tooltip: PropTypes.string,
  className: PropTypes.string,
};

export default RequestEsgButton;
